// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3tK6s","loaderOuter":"PageOverlayLoader_loaderOuter__-uPtS"};